import React, {Fragment} from 'react';
import REST from 'go/requests/rest';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {
  Segment,
  Header,
  Dropdown,
  Grid,
  Confirm,
  Message,
  Pagination,
} from 'semantic-ui-react';
import _ from 'lodash';
import {
  STATUS_PENDING_SUBMISSION,
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_RETURNED_TO_RECIPIENT,
  STATUS_PAYMENT_APPROVED,
  STATUS_PAYMENT_DENIED,
  STATUS_PAYMENT_WITHDRAWN,
  ASSOCIATED_PAYMENT_STATUSES,
} from 'app-ui-componentlibrary/dist/common/constants';
import {
  convertDateForDisplay,
  showDollarAmountWithDollar,
  convertUTCDateToLocalDateDisplay,
} from 'common/utils';

import {PAYMENT} from 'common/requestDetails/constants.js';

import {withRouter} from 'react-router-dom';
import {Toggle} from 'componentLibrary';
import {canViewPostAwardEntities} from 'go/security/permissions';
import produce from 'immer';

const PAYMENT_PAGE_SIZE = 10;

export class PaymentList extends React.Component {
  state = {
    activePage: 1,
    pageSize: PAYMENT_PAGE_SIZE,
    entities: [],
    showMessage: false,
  };

  componentDidMount() {
    this.refreshData();
  }
  componentDidUpdate(prevProps) {
    const {data} = this.props;
    if (data && data !== prevProps.data) {
      this.refreshData();
    }
  }

  refreshData() {
    const {permissions, data} = this.props;
    let entities = _.orderBy(_.omit(data, 'loading'), ['statusTimestamp'], ['desc']);
    if (!canViewPostAwardEntities(permissions)) {
      entities = _.reject(entities, (entity) => {
        return entity.status === STATUS_PENDING_SUBMISSION;
      });
    }
    this.setState({entities: entities});
  }

  onClose = () => this.setState({showMessage: false});
  show = () => this.setState({open: true});
  handleConfirm = () => {
    const {entities, selectedEntity} = this.state;
    const {dataPath, data} = this.props;
    const dataArray = _.values(_.omit(data, 'loading'));
    const entity = produce(selectedEntity, (draft) => {
      draft.status = 'withdrawn';
    });
    REST.dynamicData
      .updateEntity(this.props.token, entity)
      .then(REST.handler.handleResponse)
      .then(() => {
        let index = _.findIndex(
          dataArray,
          (result) => result.entityNumber === entity.entityNumber
        );
        const dataPathIndex = dataPath + `[${index}]`;
        this.props.saveEntitySessionData(dataPathIndex, entity);
        this.setState({
          showMessage: true,
          open: false,
        });
      });
  };
  handleCancel = () => this.setState({open: false});

  handleContinueCase(entityType, entityId) {
    const {entities} = this.state;
    const {fundingStreamType} = this.props;

    //check and make sure only one payment type
    let continueList = _.filter(entities, (entity) => {
      return entity.entityType === PAYMENT && entity.status === STATUS_PENDING_SUBMISSION;
    });

    if (continueList.length > 1 && fundingStreamType === 'hiringOfFirefighters') {
      this.props.history.push(`/${entityType}/${entityId}/view`);
    } else {
      this.props.history.push(`/${entityType}/${entityId}/edit`);
    }
  }

  doEntityAction(actionType, entity) {
    let entityType = entity.entityType;
    let entityId = entity.entityId;
    switch (actionType) {
      case 'viewRequest':
      case 'viewDecision':
        this.props.history.push(`/${entityType}/${entityId}/view`);
        break;
      case 'continue':
        this.handleContinueCase(entityType, entityId);
        break;
      case 'withdraw':
        this.setState({selectedEntity: entity}, () => this.show());
        break;
      default:
    }
  }

  renderPayments() {
    const {permissions} = this.props;
    const {entities, activePage, pageSize} = this.state;
    const entitiesToRender = _.slice(
      entities,
      (activePage - 1) * pageSize,
      activePage * pageSize
    );
    return (
      <Grid key={'paymentsGrid'} doubling stackable reversed="mobile" padded="vertically">
        <Grid.Column className="visible-overflow">
          <FemaGoTable summary={'Payment package'} type="static" columns={6}>
            <FemaGoTable.Header>
              <FemaGoTable.Row key="paymentsTableHeader">
                <FemaGoTable.HeaderCell>Payment number</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Request date</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Date of status</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell type="number">
                  Payment amount
                </FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(entitiesToRender, (entity, index) => {
                let actions = [];
                switch (entity.status) {
                  case STATUS_SUBMITTED_TO_FEMA:
                  case STATUS_PAYMENT_WITHDRAWN:
                    actions.push({
                      key: 'viewRequest',
                      text: 'View request',
                      value: 'viewRequest',
                    });
                    break;
                  case STATUS_RETURNED_TO_RECIPIENT:
                  case STATUS_PENDING_SUBMISSION:
                    if (canViewPostAwardEntities(permissions)) {
                      actions.push({
                        key: 'withdraw',
                        text: 'Withdraw request',
                        value: 'withdraw',
                      });
                      actions.push({
                        key: 'continue',
                        text: 'Continue request ',
                        value: 'continue',
                      });
                    }
                    break;
                  case STATUS_PAYMENT_APPROVED:
                  case STATUS_PAYMENT_DENIED:
                    actions.push({
                      key: 'viewDecision',
                      text: 'View FEMA decision',
                      value: 'viewDecision',
                    });
                    break;
                  default:
                }

                return (
                  <FemaGoTable.Row key={`${entity.entityId}-row`}>
                    <FemaGoTable.TextCell>
                      {`${entity.entityType} ${entity.entityNumber}`}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {`${entity.status}` === STATUS_PENDING_SUBMISSION ||
                      `${entity.status}` === STATUS_PAYMENT_WITHDRAWN
                        ? ''
                        : convertDateForDisplay(
                            _.get(entity, 'payload.request.date', entity.statusTimestamp)
                          )}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {ASSOCIATED_PAYMENT_STATUSES[entity.status] || 'N/A'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertUTCDateToLocalDateDisplay(entity.statusTimestamp)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell textAlign="right">
                      {_.toString(_.get(entity, 'payload.amount', '')) !== ''
                        ? showDollarAmountWithDollar(_.get(entity, 'payload.amount'))
                        : ''}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell textAlign="left">
                      {actions.length > 0 ? (
                        <Dropdown
                          selectOnNavigation={false}
                          selectOnBlur={false}
                          text={'Select action'}
                          name={`${entity.entityId}-action-button`}
                          id={`${entity.entityId}-action-button`}
                          onChange={(e, {name, value}) =>
                            this.doEntityAction(value, entity)
                          }
                          upward={index + 1 === _.size(entities)}
                          options={actions}
                          value={''}
                        />
                      ) : (
                        'No Actions available'
                      )}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>

          {entities.length > PAYMENT_PAGE_SIZE ? (
            <div className="pagination-wrapper pagination">
              <Pagination
                totalPages={Math.ceil(entities.length / PAYMENT_PAGE_SIZE)}
                activePage={activePage}
                onPageChange={(e, data) => this.setState({activePage: data.activePage})}
              />
            </div>
          ) : (
            ''
          )}
        </Grid.Column>
      </Grid>
    );
  }

  render() {
    const {fundingOpportunityId} = this.props;
    const {showMessage} = this.state;
    return (
      <React.Fragment>         
        <Confirm
          open={this.state.open}
          cancelButton="No"
          confirmButton="Yes"
          content="Are you sure you want to withdraw your request?"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Segment>
          {showMessage ? (
            <Message
              success
              header="Success"
              content="Payment has been withdrawn"
              onDismiss={this.onClose}
            />
          ) : null}
          <Header as={'h4'} content={'Payments'} id={'Payments'} />
          {this.renderPayments()}
        </Segment>
      </React.Fragment>      
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, null)(withRouter(connectDynamic(PaymentList)));
